



























import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import ProjectProposalUploadFiles from "../../ProjectProposal/ProjectProposalUploadFiles.vue";
import ProjectProposalFormB from "../../ProjectProposal/ProjectProposalFormB.vue";
import { TranslateResult } from "vue-i18n";
@Component({
    components: {
        ProjectProposalUploadFiles,
        ProjectProposalFormB
    }
})
export default class FileField extends Vue {
    @Prop({ type: Object, required: true }) row!: { [key: string]: string[] };
    @Prop({ type: Object, required: true }) item!: { [key: string]: string[] };
    @Prop({ type: String }) tip!: string;
    @Prop({ type: Function }) onClick!: Function;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Prop({ type: Boolean }) isRequired!: boolean; 
    @Prop({ type: Array }) isError!: string[];  
    @Prop({ type: Number }) totalFiles!: number;  

    handleClick() {
        if (this.onClick) {
            this.onClick(this.tip);
        }
    }
}
